import moment from 'moment';
import Top    from './TopPart';
import Bottom from './BottomPart';
import escapeTwig from '../escapeTwig';
import inlineQuoteStyles from '../inlineQuoteStyles';
import replyHeader from '../replyHeader';


moment.locale('de');


const baseURL = window.location.origin;

const emailParse = function (email, locale) {
    if (email) {
        let htmlText = replyHeader(email, locale);

        if (email.textHtml) {
            let content = new DOMParser().parseFromString(email.textHtml, 'text/html');
            //     Removing base because it interferes with our js code   <base href="some_url">
            // TODO - this will break the email links - find a better solution
            htmlText += '<div dir="ltr"><br></div>' + inlineQuoteStyles(content);

            // Fix relative paths for signature images
            htmlText = htmlText.replace(/\.\.\/\.\.\/clientSpecific\/email\//g, '/clientSpecific/email/');
            htmlText = htmlText.replace(/\.\.\/clientSpecific\/email\//g, '/clientSpecific/email/');

            if(email.attachments) {
                for (const attachment of email.attachments) {
                    if ((attachment.disposition === 'inline' || !attachment.disposition) && attachment.type === 'image') {
                        htmlText = htmlText.replace(
                            new RegExp('cid:' + attachment.id, 'g'),
                            '/files/' + attachment.filePath
                        );
                    }
                }
            }


        } else {
            htmlText += '<div dir="ltr"><br></div>' + email.textPlain;
        }

        return escapeTwig(htmlText);

    } else {
        return '';
    }
};


export default function (body = '', phone = '', email = null, locale = 'de_DE') {
    return Top + body + `</span></p><!-- bodyContentEnd -->
</td>
</tr>
</tbody>
</table>
</div>
</td>
</tr>
</tbody>
</table>
</td>
</tr>
<tr>
<td style="padding:0cm 15.0pt 7.5pt 15.0pt">
<table class="MsoNormalTable" border="0" cellspacing="0" cellpadding="0" width="100%" style="width:100.0%;border-collapse:collapse">
<tbody>
<tr>
<td width="560" valign="top" style="width:420.0pt;padding:0cm 0cm 0cm 0cm">
<div align="center">
<table class="MsoNormalTable" border="0" cellspacing="0" cellpadding="0" width="100%" style="width:100.0%;border-collapse:collapse">
<tbody>
<tr>
<td style="padding:11.25pt 0cm 0cm 0cm">
<div align="center">
<table class="MsoNormalTable" border="0" cellspacing="0" cellpadding="0" width="100%" style="width:100.0%;border-collapse:collapse">
<tbody>
<tr style="height:.75pt">
<td width="100%" style="width:100.0%;border:none;border-bottom:solid #CCCCCC 1.0pt;padding:0cm 0cm 0cm 0cm;height:.75pt">
</td>
</tr>
</tbody>
</table>
</div>
</td>
</tr>
</tbody>
</table>
</div>
</td>
</tr>
</tbody>
</table>
</td>
</tr>
<tr>
<td style="padding:0cm 15.0pt 0cm 15.0pt">
<table class="MsoNormalTable" border="0" cellspacing="0" cellpadding="0" width="560" style="width:420.0pt">
<tbody>
<tr>
<td width="300" valign="top" style="width:225.0pt;padding:0cm 0cm 0cm 0cm">
<table class="MsoNormalTable" border="0" cellspacing="0" cellpadding="0" align="left" style="border-collapse:collapse;margin-left:-2.25pt;margin-right:-2.25pt">
<tbody>
<tr>
<td width="280" valign="top" style="width:210.0pt;padding:0cm 0cm 0cm 0cm">
<div align="center">
<table class="MsoNormalTable" border="0" cellspacing="0" cellpadding="0" width="100%" style="width:100.0%;border-collapse:collapse">
<tbody>
<tr>
<td style="padding:7.5pt 0cm 7.5pt 0cm">
<p class="MsoNormal"><span style="font-size:1.0pt;mso-fareast-language:DE"><img width="200" height="40" style="width:2.0833in;height:.4166in" id="Grafik_x0020_64" src="/clientSpecific/email/welcome_logo_2026.png"></span><span style="font-size:1.0pt;font-family:&quot;Open Sans&quot;;mso-fareast-language:DE"><o:p></o:p></span></p>
</td>
</tr>
<tr>
<td style="padding:3.75pt 0cm 3.75pt 0cm">
<p class="MsoNormal"><b><span style="font-size:10.0pt;font-family:&quot;Open Sans&quot;;color:#6A6C6F;mso-fareast-language:DE">{{user.firstName}} {{user.lastName}}</span></b><span style="font-family:&quot;Open Sans&quot;;mso-fareast-language:DE"><o:p></o:p></span></p>
</td>
</tr>
<tr>
<td style="padding:3.75pt 0cm 0cm 0cm">
<table class="MsoNormalTable" border="0" cellspacing="0" cellpadding="0" style="border-collapse:collapse">
{% if user.phoneDirect %}
<tr>
<td valign="top" style="padding:0cm 3.75pt 0cm 0cm">
<p class="MsoNormal" style="line-height:12.0pt;mso-line-height-rule:exactly"><span style="font-size:8.5pt;font-family:&quot;Open Sans&quot;;color:black;mso-fareast-language:ZH-CN">Tel (DE):</span></p>
</td>
<td valign="top" style="padding:0cm 0cm 0cm 0cm">
<p class="MsoNormal" style="line-height:12.0pt;mso-line-height-rule:exactly"><span style="font-size:8.5pt;font-family:&quot;Open Sans&quot;;color:black;mso-fareast-language:ZH-CN">+49 30 400 535 &#8211; 400 (Dw. {{ user.phoneDirect }})</span></p>
</td>
</tr>
{% endif %}
{% if user.phoneDirectFr %}
<tr>
<td valign="top" style="padding:0cm 3.75pt 0cm 0cm">
<p class="MsoNormal" style="line-height:12.0pt;mso-line-height-rule:exactly"><span style="font-size:8.5pt;font-family:&quot;Open Sans&quot;;color:black;mso-fareast-language:ZH-CN">Tel (FR):</span></p>
</td>
<td valign="top" style="padding:0cm 0cm 0cm 0cm">
<p class="MsoNormal" style="line-height:12.0pt;mso-line-height-rule:exactly"><span style="font-size:8.5pt;font-family:&quot;Open Sans&quot;;color:black;mso-fareast-language:ZH-CN">+33 1 53 36 &#8211; 1800 (Dw. {{ user.phoneDirectFr }})</span></p>
</td>
</tr>
{% endif %}
{% if not user.phoneDirect and not user.phoneDirectFr %}
<tr>
<td valign="top" style="padding:0cm 3.75pt 0cm 0cm">
<p class="MsoNormal" style="line-height:12.0pt;mso-line-height-rule:exactly"><span style="font-size:8.5pt;font-family:&quot;Open Sans&quot;;color:black;mso-fareast-language:ZH-CN">Tel:</span></p>
</td>
<td valign="top" style="padding:0cm 0cm 0cm 0cm">
<p class="MsoNormal" style="line-height:12.0pt;mso-line-height-rule:exactly"><span style="font-size:8.5pt;font-family:&quot;Open Sans&quot;;color:black;mso-fareast-language:ZH-CN">+41 24 463 00 88</span></p>
</td>
</tr>
{% endif %}
</table>
</td>
</tr>
<tr>
<td style="padding:3.75pt 0cm 0cm 0cm">
<p class="MsoNormal" style="line-height:12.0pt;mso-line-height-rule:exactly"><span style="mso-fareast-language:DE"><a href="mailto:{{user.getEmailByOrganisationId(3)}}"><span style="font-size:8.5pt;font-family:&quot;Open Sans&quot;;color:#C86A0A;mso-fareast-language:ZH-CN">{{user.getEmailByOrganisationId(3)}}</span></a></span><span style="font-size:10.0pt;font-family:&quot;Open Sans&quot;;color:black;display:none;mso-fareast-language:ZH-CN">&nbsp;</span><span style="font-size:10.0pt;font-family:&quot;Open Sans&quot;;color:black;mso-fareast-language:ZH-CN"><o:p></o:p></span></p>
</td>
</tr>
<tr>
<td style="padding:3.75pt 0cm 0cm 0cm">
<p class="MsoNormal" style="line-height:12.0pt;mso-line-height-rule:exactly"><span style="mso-fareast-language:DE"><a href="https://www.welcome-tours.com/"><span style="font-size:8.5pt;font-family:&quot;Open Sans&quot;;color:#C86A0A;mso-fareast-language:ZH-CN">www.welcome-tours.com</span></a></span><span style="font-size:10.0pt;font-family:&quot;Open Sans&quot;;color:black;display:none;mso-fareast-language:ZH-CN">&nbsp;</span><span style="font-size:10.0pt;font-family:&quot;Open Sans&quot;;color:black;mso-fareast-language:ZH-CN"><o:p></o:p></span></p>
</td>
</tr>
</tbody>
</table>
</div>
</td>
<td width="20" style="width:15.0pt;padding:0cm 0cm 0cm 0cm"></td>
</tr>
</tbody>
</table>
</td>
<td width="120" valign="top" style="width:90.0pt;padding:0cm 0cm 0cm 0cm">
</td>
<td width="20" style="width:15.0pt;padding:0cm 0cm 0cm 0cm"></td>
<td width="120" valign="top" style="width:90.0pt;padding:0cm 0cm 0cm 0cm">
<table class="MsoNormalTable" border="0" cellspacing="0" cellpadding="0" align="right" style="border-collapse:collapse;margin-left:-2.25pt;margin-right:-2.25pt">
<tbody>
<tr>
<td width="120" style="width:90.0pt;padding:0cm 0cm 0cm 0cm">
<table class="MsoNormalTable" border="0" cellspacing="0" cellpadding="0" width="100%" style="width:100.0%;border-collapse:collapse">
<tbody>
<tr>
<td style="padding:0cm 0cm 0cm 0cm">
<p class="MsoNormal" align="center" style="text-align:center"><a href="https://buspaketbln.sharepoint.com/:b:/s/Public/IQD98Uu-7ndLRK3jWIHZITDcARhiPr_AbOW93ck7qtFIEpM?e=MyB81K&amp;download=1" target="_blank"><span style="font-size:10.0pt;color:#C86A0A;mso-fareast-language:DE;text-decoration:none"><img border="0" width="121" height="170" style="width:1.2604in;height:1.7708in" id="Grafik_x0020_66" src="/clientSpecific/email/welcome_katalog_27.png"></span></a><span style="font-size:1.0pt;font-family:&quot;Open Sans&quot;;mso-fareast-language:DE"><o:p></o:p></span></p>
</td>
</tr>
<tr>
<td style="padding:0cm 0cm 0cm 0cm">
<p class="MsoNormal" align="center" style="text-align:center;line-height:12.0pt;mso-line-height-rule:exactly">
<span style="mso-fareast-language:DE"><a href="https://buspaketbln.sharepoint.com/:b:/s/Public/IQD98Uu-7ndLRK3jWIHZITDcARhiPr_AbOW93ck7qtFIEpM?e=MyB81K&amp;download=1" target="_blank"><span style="font-size:8.5pt;font-family:&quot;Open Sans&quot;;color:#C86A0A;mso-fareast-language:ZH-CN">Welcome&nbsp;Tours&nbsp;Katalog&nbsp;27</span></a></span><u><span style="font-size:10.0pt;font-family:&quot;Open Sans&quot;;color:#6A6C6F;mso-fareast-language:ZH-CN"><o:p></o:p></span></u></p>
</td>
</tr>
</tbody>
</table>
</td>
</tr>
</tbody>
</table>
</td>
</tr>
</tbody>
</table>
</td>
</tr>
<tr>
<td style="padding:0cm 0cm 0cm 0cm">
<table class="MsoNormalTable" border="0" cellspacing="0" cellpadding="0" width="100%" style="width:100.0%;border-collapse:collapse">
<tbody>
<tr>
<td width="600" valign="top" style="width:450.0pt;padding:0cm 0cm 0cm 0cm">
<div align="center">
<table class="MsoNormalTable" border="0" cellspacing="0" cellpadding="0" width="100%" style="width:100.0%;border-collapse:collapse">
<tbody>
<tr>
<td style="padding:7.5pt 15.0pt 7.5pt 15.0pt">
<div align="center">
<table class="MsoNormalTable" border="0" cellspacing="0" cellpadding="0" width="100%" style="width:100.0%;border-collapse:collapse">
<tbody>
<tr style="height:.75pt">
<td width="100%" style="width:100.0%;border:none;border-bottom:solid #CCCCCC 1.0pt;padding:0cm 0cm 0cm 0cm;height:.75pt">
</td>
</tr>
</tbody>
</table>
</div>
</td>
</tr>
</tbody>
</table>
</div>
</td>
</tr>
</tbody>
</table>
</td>
</tr>
</tbody>
</table>
</td>
</tr>
<tr>
<td style="padding:0cm 0cm 0cm 0cm">
<table class="MsoNormalTable" border="0" cellspacing="0" cellpadding="0" align="left" width="600" style="width:450.0pt;border-collapse:collapse;margin-left:-2.25pt;margin-right:-2.25pt">
<tbody>
<tr>
<td style="padding:0cm 15.0pt 0cm 15.0pt">
<table class="MsoNormalTable" border="0" cellspacing="0" cellpadding="0" width="100%" style="width:100.0%;border-collapse:collapse">
<tbody>
<tr>
<td width="560" valign="top" style="width:420.0pt;padding:0cm 0cm 0cm 0cm">
<div align="center">
<table class="MsoNormalTable" border="0" cellspacing="0" cellpadding="0" width="100%" style="width:100.0%;border-collapse:collapse">
<tbody>
<tr>
<td style="padding:0cm 0cm 0cm 0cm">
<p class="MsoNormal" align="center" style="text-align:center;line-height:9.75pt;mso-line-height-rule:exactly">
<span style="mso-fareast-language:DE"><a href="https://www.welcome-tours.com/"><span style="font-size:10.0pt;font-family:&quot;Open Sans&quot;;color:#C86A0A;mso-fareast-language:ZH-CN">www.welcome-tours.com</span></a></span><span style="font-size:10.0pt;font-family:&quot;Open Sans&quot;;color:black;mso-fareast-language:ZH-CN"> | <a href="mailto:info@welcome-tours.com"><span style="color:#C86A0A">info@welcome-tours.com</span></a></span><span style="font-size:10.0pt;font-family:&quot;Open Sans&quot;;color:#6A6C6F;mso-fareast-language:ZH-CN"><o:p></o:p></span></p>
</td>
</tr>
<tr>
<td style="padding:7.5pt 15.0pt 7.5pt 15.0pt">
<div align="center">
<table class="MsoNormalTable" border="0" cellspacing="0" cellpadding="0" width="75%" style="width:75.0%;border-collapse:collapse">
<tbody>
<tr style="height:.75pt">
<td width="100%" style="width:100.0%;border:none;border-bottom:solid #CCCCCC 1.0pt;padding:0cm 0cm 0cm 0cm;height:.75pt">
</td>
</tr>
</tbody>
</table>
</div>
</td>
</tr>
</tbody>
</table>
</div>
</td>
</tr>
</tbody>
</table>
</td>
</tr>
<tr>
<td style="padding:0cm 15.0pt 0cm 15.0pt">
<table class="MsoNormalTable" border="0" cellspacing="0" cellpadding="0" width="100%" style="width:100.0%;border-collapse:collapse">
<tbody>
<tr>
<td width="560" valign="top" style="width:420.0pt;padding:0cm 0cm 0cm 0cm">
<div align="center">
<table class="MsoNormalTable" border="0" cellspacing="0" cellpadding="0" width="100%" style="width:100.0%;border-collapse:collapse">
<tbody>
<tr>
<td style="padding:0cm 0cm 0cm 0cm">
<p class="MsoNormal" align="center" style="text-align:center;line-height:9.75pt;mso-line-height-rule:exactly">
<span style="font-size:8.5pt;font-family:&quot;Open Sans&quot;;color:black;mso-fareast-language:ZH-CN">Welcome Tours SA | Avenue de la Gare 24 | CH &#8211; 1880 Bex | +41 24 463 00 88</span></p>
<p class="MsoNormal" align="center" style="text-align:center;line-height:9.75pt;mso-line-height-rule:exactly;margin-top:3.0pt">
<span style="font-size:8.5pt;font-family:&quot;Open Sans&quot;;color:black;mso-fareast-language:ZH-CN">Office Paris | 9 Villa Brune | F &#8211; 75014 Paris | +33 1 53 36 18 00</span><span style="font-size:8.5pt;font-family:&quot;Open Sans&quot;;color:#6A6C6F;mso-fareast-language:ZH-CN"><o:p></o:p></span></p>
<p class="MsoNormal" align="center" style="text-align:center;margin-top:7.5pt"><span style="mso-fareast-language:DE"><img border="0" width="560" height="5" style="width:5.8333in;height:.052in" id="Grafik_x0020_70" src="/clientSpecific/email/test2.jpg"></span></p>
</td>
</tr>
</tbody>
</table>
</div>
</td>
</tr>
</tbody>
</table>
</td>
</tr>
</tbody>
</table>
</td>
</tr>
</tbody>
</table>
</div>
</td>
</tr>
</tbody>
</table>
<p class="MsoNormal"><span style="mso-fareast-language:DE"><o:p>&nbsp;</o:p></span></p>
<p class="MsoNormal"><o:p>&nbsp;</o:p></p>
</div>
</body>
</html>` +
    emailParse(email, locale) +

    Bottom;
}
